import axios, { isAxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

type HttpMethod = 'get' | 'post' | 'put' | 'delete' | 'patch' | 'head' | 'options';

const createSecureAxios = (config: AxiosRequestConfig = {}): AxiosInstance => {
    const instance = axios.create(config);

    const methods: HttpMethod[] = ['get', 'post', 'put', 'delete', 'patch', 'head', 'options'];

    methods.forEach((method) => {
        const originalMethod = (instance as any)[method];

        (instance as any)[method] = function (...args: any[]): any {
            let requestUrl: string | undefined;
            const [urlOrConfig] = args;

            if (typeof urlOrConfig === 'string') {
                requestUrl = urlOrConfig;
            } else if (urlOrConfig && typeof urlOrConfig === 'object') {
                requestUrl = urlOrConfig.url;
            }

            if (instance.defaults.baseURL && requestUrl) {
                try {
                    const baseUrlObj = new URL(instance.defaults.baseURL);
                    const requestUrlObj = new URL(requestUrl, instance.defaults.baseURL);

                    if (!requestUrlObj.hostname.endsWith(baseUrlObj.hostname)) {
                        throw new Error(
                            `Security violation: Request URL ${requestUrl} is outside the allowed baseURL domain ${instance.defaults.baseURL}`
                        );
                    }
                } catch (error) {
                    if (requestUrl.startsWith('http://') || requestUrl.startsWith('https://')) {
                        throw new Error(
                            `Security violation: Absolute URL ${requestUrl} not allowed when baseURL is set`
                        );
                    }
                }
            }

            return originalMethod.apply(this, args);
        };
    });

    return instance;
};

const secureAxios: AxiosInstance = createSecureAxios();

export default secureAxios;
export { createSecureAxios };
export type { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError };
export { isAxiosError };
